import { render, staticRenderFns } from "./PairsSymbols.vue?vue&type=template&id=0a659d12"
import script from "./PairsSymbols.vue?vue&type=script&lang=js"
export * from "./PairsSymbols.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports